import { SegmentFragment, SegmentsQuery } from '@occc/graphql';

export const transformDataToSegmentsArray = (data: SegmentsQuery): SegmentFragment[] =>
  data?.segments.edges.map((e) => e.node);
